<template>
    <div class="relative min-h-screen antialiased bg-white sans-serif">
        <div class="absolute right-5 md:right-44">
            <div class="flex gap-4">
                <button
                    v-if="!isRetailer"
                    v-print="printObj"
                    title="Print"
                    class="p-1 rounded-full cursor-pointer hover:bg-gray-200"
                >
                    <PrintIcon class="w-5" />
                </button>

                <button
                    title="Reload"
                    class="p-1 rounded-full cursor-pointer hover:bg-gray-200"
                    @click="reload"
                >
                    <ReplaceIcon />
                </button>
            </div>
        </div>
        <div
            id="print-invoice"
            class="px-6 my-6 md:px-44"
        >
            <div class="text-2xl font-bold uppercase">Invoice</div>

            <div class="flex items-start justify-between my-8">
                <div class="">
                    <div class="flex flex-col mb-2 md:flex-row">
                        <p>Invoice No :</p>
                        <p class="px-2 font-semibold rounded bg-green-50">#{{ bill.bill_number }}</p>
                    </div>
                    <div class="flex flex-col mb-2 md:flex-row">
                        <p>Date :</p>
                        <p class="px-2 font-semibold rounded bg-green-50">
                            {{ bill.created_at | readableDate }}
                        </p>
                    </div>
                    <div class="flex flex-col mb-2 md:flex-row">
                        <p>Payment Method :</p>
                        <p class="px-2 font-semibold rounded bg-green-50">
                            {{ bill.payment_method }}
                        </p>
                    </div>
                </div>

                <div class="rounded bg-blue-50 w-28 h-28">
                    <!-- <img
                        src=""
                        alt="Logo"
                        class="object-fill w-full h-full"
                    > -->
                    Logo here
                </div>
            </div>

            <!-- Participant's info  -->
            <div class="flex flex-col justify-between md:flex-row md:gap-20">
                <div class="w-full md:w-1/2">
                    <div class="mb-2 font-semibold">Bill To:</div>

                    <div class="p-2 mb-2 rounded bg-green-50">
                        {{ bill.user.name }}
                    </div>

                    <div>
                        <p>Address:</p>
                        <p class="p-2 mb-2 rounded bg-green-50">
                            {{ bill.user.kyc.business_address }}
                        </p>
                    </div>
                </div>
                <div class="md:w-1/2">
                    <div class="mb-2 font-semibold">From:</div>

                    <div class="p-2 mb-2 rounded bg-green-50">
                        {{ bill.wholesaler.name }}
                    </div>
                    <div>
                        <p>Address:</p>
                        <p class="p-2 mb-2 rounded bg-green-50">
                            {{ bill.wholesaler.kyc.business_address }}
                        </p>
                    </div>
                </div>
            </div>

            <!-- Transation table  -->
            <div class="my-8">
                Descriptions
                <table class="w-full my-2 border border-collapse border-green-200 table-auto bg-green-50">
                    <thead class="bg-green-200">
                        <tr>
                            <th class="border border-green-100">S.N.</th>
                            <th class="border border-green-100">Item</th>
                            <th class="border border-green-100">Qty</th>
                            <th class="border border-green-100">Unit Price</th>
                            <th class="border border-green-100">Total</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr
                            v-for="(transaction, index) in bill.transactions"
                            :key="transaction.id"
                        >
                            <td class="px-2 text-center border border-green-300">
                                {{ index + 1 }}
                            </td>
                            <td class="px-2 text-center border border-green-300">
                                {{ transaction.product.name }}
                            </td>
                            <td class="px-2 text-center border border-green-300">
                                {{ transaction.qty }}
                            </td>
                            <td class="px-2 text-center border border-green-300">
                                {{ config(common.currency) }} {{ transaction.product.price }}
                            </td>
                            <td class="px-2 text-center border border-green-300">
                                {{ config(common.currency) }} {{ transaction.grand_total }}
                            </td>
                        </tr>
                    </tbody>
                </table>

                <div class="flex justify-end font-semibold">
                    <div>
                        <div>
                            Grand Total : {{ config(common.currency) }} {{ parseFloat(bill.total_amount).toFixed(2) }}
                        </div>
                        <div>
                            Paid Amount : {{ config(common.currency) }} {{ parseFloat(bill.amount_paid).toFixed(2) }}
                        </div>
                        <div v-if="parseFloat(bill.amount_remaining)">
                            Remaining Amount : {{ config(common.currency) }}
                            {{ parseFloat(bill.amount_remaining).toFixed(2) }}
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="bill.notes">
                Notes
                <div class="p-2 my-2 rounded bg-green-50">
                    {{ bill.notes }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import print from 'vue-print-nb';
    import common from '../common';
    import ReplaceIcon from '../Components/Icons/ReplaceIcon.vue';
    import PrintIcon from '../Components/Icons/PrintIcon.vue';

    export default {
        name: 'InvoiceComponent',

        directives: {
            print,
        },

        components: {
            ReplaceIcon,
            PrintIcon,
        },

        props: {
            bill: {
                type: Object,
                required: true,
            },
        },

        data() {
            return {
                common,
                printObj: {
                    id: '#print-invoice',
                    popTitle: 'B2B Shopping',
                    // extraCss: 'https://www.google.com,https://www.google.com',
                    extraHead: '<link href="https://unpkg.com/tailwindcss@^2/dist/tailwind.min.css" rel="stylesheet">',
                },
            };
        },

        methods: {
            reload() {
                window.location.reload();
            },
        },
    };
</script>
